<script>
	/* TAILWIND Imports for plugin visibility */
	import "$lib/style/0001-core.scss";


	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
	import { browser } from '$app/environment';
  
	/* IMPORT: 3RD-PARTY */
	/* IMPORT: CUSTOM JS */
	import Onionskin from '$lib/component/group/onionskin.svelte';
	import Link from '$lib/component/element/link.svelte';
	import SiteHeader from '$lib/component/site/site-header.svelte';
	import SiteFooter from '$lib/component/site/site-footer.svelte';

	import { storeDevice, storeShopifyCart, storeShopifyProducts } from '$lib/script/store.js';
	import { tailwind } from '$lib/script/tailwind.js';
	import { historyScrollRestoration } from '$lib/script/history.js';
	import { scroll } from '$lib/script/scroll.js';
	import { deviceInit } from '$lib/script/device.js';

	/* Svelte Methods */
	const getCartDataNew = ( _data ) =>
	{
		$storeShopifyCart = _data;
		console.log( 'Shopify Cart.' );
		console.log( $storeShopifyCart );
	};
	
   // Handle readiness [ window, document, browser, storeGlobal, ...]
	onMount( async () => 
	{
		$storeDevice = deviceInit({
			deviceViewportSizes: tailwind.theme.screens,
			deviceLoadCallbacks: [[( _event, _device ) => 
			{ 
				if ( !_device.deviceIsMobile && typeof( _device.deviceIsMobile ) === 'boolean' )
				{
					scroll({ 
						element: document.querySelector('.site'),
						inertia: 0.0725, // Float, best results less than 0.07
						easing: 2, // Whole,
						active: false
					});
				}

				historyScrollRestoration( 'manual' );

				// Handle off-store shopify cart info
				const script=document.createElement("script");
				script.src="https://store.zmax.com/cart.json?callback=getCartDataNew";
				document.getElementsByTagName("head")[0].appendChild(script);
				
				const storeTemp = setInterval( () => 
				{	
					if ( window.storeShopifyCart )
					{
						$storeShopifyCart = window.storeShopifyCart;
						clearInterval( storeTemp );
					}
				}, 100);
				
			}, null]],
			// deviceResizeCallbacks: [[( _event ) => { console.log( 'Device Resize CB' ) }, null]],
			// deviceResizeDebounceCallbacks: [[( _event ) => { console.log( 'Device DebounceResize CB' ) }, null]]
		});

	});

</script>

<svelte:head>

	<script>

		const getCartDataNew = ( _data ) =>
		{
			window.storeShopifyCart = _data;
		};

	</script>

</svelte:head>


<!-- <Onionskin data={ { active: false, toggle: true, mouse: true, opacity: .5, zindex: 1000000, lineBgColor: '#FF0000', lineWidth: '3px', grayscale: '100%' } }>
	<source srcset='/lib/image/onionskin/home-1920.jpg' media='(min-width: 768px' />
	<source srcset='/lib/image/onionskin/home-768.jpg' media='(max-width: 767px' />
	<img src='/lib/image/onionskin/home-768.jpg' alt='' />
</Onionskin> -->

<SiteHeader />

<slot />

<SiteFooter />

<style lang='scss'>

	// @import "/lib-legacy/style/zmax-style-0000-pagebody.css";
	// @import "/lib-legacy/style/zmax-style-0000-pagebody-testimonials.css";
</style>